<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="exchange_rate">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 md9 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Valuación - {{ company.nombre }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onCancel" v-on="on">
                                        <v-icon>cancel</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cancelar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-5">
                                <v-divider></v-divider>
                                <v-list-item @click="onCancel">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">cancel</v-icon>&nbsp; Cancelar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para Información: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para Información: -->
                        <v-layout row>
                            <v-flex xs12>
                                <v-card color="grey lighten-5">
                                    <v-card-text>
                                        <v-container fluid pa-1>
                                            <!-- <v-layout row>
                                                <v-flex class="title">Tipo de Valuación:</v-flex>
                                            </v-layout>-->
                                            <v-layout row wrap justify-space-between>
                                                <v-flex
                                                    xs4
                                                    sm3
                                                    class="title pt-sm-5"
                                                >Tipo de Valuación:</v-flex>
                                                <v-flex xs8 sm5>
                                                    <v-radio-group
                                                        v-model="valuationType"
                                                        :mandatory="true"
                                                        row
                                                    >
                                                        <v-radio
                                                            label="Empresa"
                                                            value="0"
                                                            color="orange accent-4"
                                                            @change="onEmpresa"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="Unidad de Negocios"
                                                            value="1"
                                                            color="orange accent-4"
                                                            @change="onUnidadDeNegocios"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-select
                                                        :disabled="valuationType === '0'"
                                                        :items="userBusinessUnits"
                                                        prepend-icon="business_center"
                                                        item-text="nombreUsuario"
                                                        item-value="unidadnegocioid"
                                                        v-model="businessUnitID"
                                                        label="Unidad de Negocios"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay unidades de negocio asignadas"
                                                        v-on:input="onSelectBusinessUnit"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-flex xs12 md2 class="title pt-sm-5">Ventas:</v-flex>
                                                <v-flex xs9 md4 class="text-center">
                                                    <v-text-field
                                                        prepend-icon="attach_money"
                                                        name="sales"
                                                        type="text"
                                                        color="teal darken-3"
                                                        v-model="salesText"
                                                        reverse
                                                        readonly
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs3 md2 offset-md1 class="text-center">
                                                    <v-text-field
                                                        name="tamanio"
                                                        label="Tamaño"
                                                        prepend-icon="height"
                                                        type="text"
                                                        v-model="size"
                                                        color="teal darken-3"
                                                        readonly
                                                        reverse
                                                        prefix="%"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs8 sm6 md6 class="text-center">
                                                    <v-text-field
                                                        prepend-icon="work"
                                                        name="puesto"
                                                        label="Puesto"
                                                        type="text"
                                                        v-model="puesto"
                                                        ref="puesto_field"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs8 sm6 md6>
                                                    <v-select
                                                        :items="userDepartments"
                                                        prepend-icon="party_mode"
                                                        item-text="nombreUsuario"
                                                        item-value="usuariosdireccionesid"
                                                        v-model="departmentID"
                                                        label="Dirección"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay direcciones asignadas"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs4>
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        onSelectFunction
                                                        text
                                                        @click="onSelectFunction"
                                                    >Seleccionar Función</v-btn>
                                                </v-flex>
                                                <v-flex xs8>
                                                    <v-text-field
                                                        prepend-icon="assignment"
                                                        name="funcion"
                                                        label="Función/Especialidad"
                                                        type="text"
                                                        v-model="valFunctionName"
                                                        color="teal darken-3"
                                                        readonly
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs8>
                                                    <v-select
                                                        :items="userRoles"
                                                        prepend-icon="star_border"
                                                        item-text="nombre"
                                                        item-value="usuariosrolesid"
                                                        v-model="usuariosrolesid"
                                                        label="Rol"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay roles asignados"
                                                        v-on:input="onSelectRole"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs8>
                                                    <v-select
                                                        :disabled="usuariosrolesid === 0"
                                                        :items="itemsFactor1"
                                                        prepend-icon="star_half"
                                                        item-text="text"
                                                        item-value="value"
                                                        v-model="factor1"
                                                        :label="labelFactor1"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                    ></v-select>
                                                </v-flex>
                                                <!-- <v-flex xs6 sm8>
                                                    <v-simple-table light dense height="120px">
                                                        <template v-slot: default>
                                                            <tbody>
                                                                <tr
                                                                    v-for="item in talentoItems"
                                                                    :key="item.value"
                                                                >
                                                                    <td
                                                                        class="caption"
                                                                    >{{ item.value }}</td>
                                                                    <td
                                                                        class="caption"
                                                                    >{{ item.text }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-flex>-->
                                            </v-layout>
                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs8>
                                                    <v-select
                                                        :disabled="usuariosrolesid === 0"
                                                        :items="itemsFactor2"
                                                        prepend-icon="star_half"
                                                        item-text="text"
                                                        item-value="value"
                                                        v-model="factor2"
                                                        :label="labelFactor2"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout align-center justify-end row fill-height>
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onValuate"
                                                    >Realizar Valuación</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Modal para pedir que se introuzcan todos los campos: *********************************** -->

                                            <v-layout row justify-center>
                                                <v-dialog
                                                    v-model="bInvalidData"
                                                    persistent
                                                    :max-width="errorModalWidth"
                                                >
                                                    <v-card class="grey lighten-4">
                                                        <v-toolbar dense color="teal" dark flat>
                                                            <v-toolbar-title
                                                                class="my-list-title"
                                                            >Información Incompleta</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>error_outline</v-icon>
                                                        </v-toolbar>
                                                        <v-card-title>
                                                            <v-container>
                                                                <v-layout row>
                                                                    <v-flex
                                                                        xs12
                                                                        class="d-flex justify-center"
                                                                    >
                                                                        <v-icon
                                                                            large
                                                                            color="orange darken-2"
                                                                        >warning</v-icon>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row>
                                                                    <v-flex
                                                                        xs12
                                                                        class="d-flex justify-center text-center"
                                                                    >{{ errorMessage }}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-title>

                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                color="teal darken-3"
                                                                class="text-none"
                                                                text
                                                                @click="bInvalidData = false"
                                                            >OK</v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>
                                            </v-layout>
                                            <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <!-- Modal para seleccionar una función: *********************************** -->
                        <v-layout v-if="showValFunctionDlg" row justify-center>
                            <v-dialog v-model="showValFunctionDlg" persistent width="90%">
                                <company-function-select
                                    :companyID="company.empresaid"
                                    :companyName="company.nombre"
                                ></company-function-select>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para seleccionar una función *************************** -->

                        <!-- Modal para los Resultados de la Valuación: *********************************** -->
                        <!-- Con v-if el componente es destruido cada vez que v-if es falso, con lo que
                        nos aseguramos de que el componente sea creado cada vez que se muestra. Con esto la función
                        created() es llamada en el componente cada vez que v-if es verdadero:-->
                        <v-layout v-if="showResultsDlg" row justify-center>
                            <v-dialog
                                v-model="showResultsDlg"
                                persistent
                                :max-width="resultsModalWidth"
                            >
                                <results></results>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para los Resultados *************************** -->
                    </v-container>
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';
import CompanyFunctionSelect from '@/components/CompanyFunctionSelect';
import Results from '@/components/Results';

export default {
    name: 'Valuation',
    data() {
        return {
            drawer: false,
            bInvalidData: false,
            errorMessage: '',

            valuationType: '0', //0 = company, 1 = business unit
            currency: '1', //1 = mxp, 2 = usd
            sales: 0,
            salesText: '',
            size: 0,
            factors: [1, 2, 3, 4, 5],
            puesto: '',
            businessUnitID: 0,
            departmentID: 0,
            usuariosrolesid: 0,
            usuariosfuncionesid: 0,
            factor1: 0,
            factor2: 0,
            labelFactor1: '',
            labelFactor2: '',
            itemsFactor1: [],
            itemsFactor2: [],
            talentoItems: [
                {
                    value: 1,
                    text:
                        '1 - El perfil mínimo requerido es muy inferior al típico para este rol.'
                },
                {
                    value: 2,
                    text:
                        '2 - El perfil mínimo requerido es un poco menor al típico para este rol.'
                },
                {
                    value: 3,
                    text:
                        '3 - El perfil mínimo requerido es el típico para este rol.'
                },
                {
                    value: 4,
                    text:
                        '4 - El perfil mínimo requerido es ligeramente mayor al típico para este rol.'
                },
                {
                    value: 5,
                    text:
                        '5 - El perfil mínimo requerido es muy superior al típico para el rol.'
                }
            ],
            contribucionItems: [
                {
                    value: 1,
                    text:
                        '1 - La contribución esperada es muy inferior a la típica para el rol.'
                },
                {
                    value: 2,
                    text:
                        '2 - La contribución esperada es claramente inferior a la típica del rol.'
                },
                {
                    value: 3,
                    text:
                        '3 - La contribución esperada es equivalente o similar a la típica para el rol.'
                },
                {
                    value: 4,
                    text:
                        '4 - La contribución esperada es claramente superior a la típica del rol.'
                },
                {
                    value: 5,
                    text:
                        '5 - La contribución esperada es muy superior a la típica para el rol.'
                }
            ],
            nivelReporteItems: [
                {
                    value: 1,
                    text:
                        '1 - Reporta a cualquier puesto pero da servicio al público (recepción y/o conmutador).'
                },
                {
                    value: 2,
                    text:
                        '2 - Reporta a uno o más puestos de nivel gerencial o inferior en tareas de soporte.'
                },
                {
                    value: 3,
                    text:
                        '3 - Reporta a uno o más puestos de nivel subdirección en labores de soporte/asistencia.'
                },
                {
                    value: 4,
                    text:
                        '4 - Reporta a uno o más puestos de dirección (de 1er. nivel) en labores de soporte/asistencia.'
                },
                {
                    value: 5,
                    text:
                        '5 - Reporta a la dirección general en labores de soporte/asistencia.'
                }
            ],
            segundoIdiomaItems: [
                {
                    value: 1,
                    text:
                        '1 - No se requiere aplicar ningún conocimiento de un segundo idioma.'
                },
                {
                    value: 2,
                    text:
                        '2 - Un segundo idioma (leer notas o etiquetas muy sencillas).'
                },
                {
                    value: 3,
                    text:
                        '3 - Habilidad para conversar con eficacia en temas sencillos o leer cualquier tipo de texto.'
                },
                {
                    value: 4,
                    text:
                        '4 - Sostener una conversación fluidamente y leer e interpretar textos especializados.'
                },
                {
                    value: 5,
                    text:
                        '5 - Dominio absoluto de un 2o idioma para usarlo en gran parte la jornada diaria.'
                }
            ]
        };
    },
    components: {
        CompanyFunctionSelect,
        Results
    },
    created() {
        console.log('User Roles: ', this.userRoles);
        this.showSelectFunctionDlg = false;
        this.valFunctionID = 0;
        this.valFunctionName = '';
        this.sales = this.companySales;
        this.salesText = this.sales;
        if (this.companySalesCurrency === 1) {
            this.salesText += ' Millones de Pesos';
        } else if (this.companySalesCurrency === 2) {
            this.salesText += ' Millones de Dólares';
        }
        this.currency = this.companySalesCurrency.toString(10);
        console.log('Currency on Created(): ', this.currency);
        console.log('BusinessUnitID = ', this.businessUnitID);
        console.log('userBusinessUnits: ', this.userBusinessUnits);
        this.size = this.companySize;
    },
    methods: {
        onCancel() {
            this.$router.push('/');
        },
        onEmpresa() {
            //Al parecer el valor this.valuationType se actualiza hasta después de
            //terminada esta función, por lo que en la función getSize this.valuationType
            //todavía tiene el valor anterior. Por lo tanto, hay que forzar a que
            //this.valuationType sea "1":

            this.valuationType = '0';
            this.businessUnitID = 0;
            console.log('onEmpresa, valuationType = ', this.valuationType);

            // this.getSize();
            this.sales = this.companySales;
            this.salesText = this.companySales;
            if (this.companySalesCurrency === 1) {
                this.salesText += ' Millones de Pesos';
            } else if (this.companySalesCurrency === 2) {
                this.salesText += ' Millones de Dólares';
            }

            this.currency = this.companySalesCurrency.toString(10);
            this.size = this.companySize;
        },

        onUnidadDeNegocios() {
            console.log(
                'onUnidadDeNegocios, valuationType = ',
                this.valuationType
            );
        },

        onSelectBusinessUnit() {
            var i;
            console.log('businessUnitID = ', this.businessUnitID);
            console.log('userBusinessUnits = ', this.userBusinessUnits);

            for (i = 0; i < this.userBusinessUnits.length; i++) {
                if (
                    this.userBusinessUnits[i].unidadnegocioid ===
                    this.businessUnitID
                ) {
                    this.sales = this.userBusinessUnits[i].ventas;
                    this.salesText = this.sales;
                    if (this.userBusinessUnits[i].moneda === 1) {
                        this.salesText += ' Millones de Pesos';
                    } else if (this.userBusinessUnits[i].moneda === 2) {
                        this.salesText += ' Millones de Dólares';
                    }
                    this.currency = this.userBusinessUnits[i].moneda.toString(
                        10
                    );
                    this.size = this.userBusinessUnits[i].tamanio;
                    break;
                }
            }
        },

        // onSalesChanged() {
        //     this.getSize();
        // },

        // onMXP() {
        //     //Al parecer el valor this.currency se actualiza hasta después de
        //     //terminada esta función, por lo que en la función getSize this.currency
        //     //todavía tiene el valor anterior. Por lo tanto, hay que forzar a que
        //     //this.currency sea "1":
        //     this.currency = '1';
        //     this.getSize();
        // },

        // onUSD() {
        //     //Al parecer el valor this.currency se actualiza hasta después de
        //     //terminada esta función, por lo que en la función getSize this.currency
        //     //todavía tiene el valor anterior. Por lo tanto, hay que forzar a que
        //     //this.currency sea "2":
        //     this.currency = '2';
        //     this.getSize();
        // },

        // getSize() {
        //     //Sólo se obtiene el tamaño de la empresa si hay ventas y si el tipo de valuación es de empresa o el tipo
        //     //de valuación es de unidad de negocios y hay una unidad de negocios seleccionada:
        //     if (
        //         this.sales != 0 &&
        //         (this.valuationType === '0' ||
        //             (this.valuationType === '1' && this.businessUnit !== 0))
        //     ) {
        //         var entidad = '';

        //         //Si está seleccionada una unidad de negocios, la entidad es el nombre de la
        //         //unidad de negocios, si no, la entidad es el nombre de la empresa:
        //         if (this.businessUnitID === 0) {
        //             entidad = this.company.nombre;
        //         } else {
        //             var i;
        //             for (i = 0; i < this.userBusinessUnits.length; i++) {
        //                 if (
        //                     this.userBusinessUnits[i]
        //                         .unidadnegocioid ===
        //                     this.businessUnitID
        //                 ) {
        //                     entidad = this.userBusinessUnits[i].nombreUsuario;
        //                 }
        //             }
        //         }

        //         var salesData = {
        //             entidad: entidad,
        //             ventas: this.sales,
        //             moneda: this.currency,
        //             empresaid: this.company.empresaid
        //         };
        //         console.log('salesData = ', salesData);
        //         this.$store.dispatch('getCompanySize', salesData);
        //     }
        // },

        onSelectFunction() {
            this.$store.dispatch(
                'showFunctionsForValuationDlg',
                this.company.empresaid
            );
        },

        onSelectRole() {
            this.factor1 = 0;
            this.factor2 = 0;
            var i;
            for (i = 0; i < this.userRoles.length; i++) {
                if (
                    this.userRoles[i].usuariosrolesid === this.usuariosrolesid
                ) {
                    this.labelFactor1 = this.userRoles[i].factor1;
                    this.labelFactor2 = this.userRoles[i].factor2;
                }
            }

            if (this.labelFactor1 === 'Talento') {
                this.itemsFactor1 = this.talentoItems;
            } else {
                this.itemsFactor1 = this.nivelReporteItems;
            }

            if (this.labelFactor2 === 'Contribución') {
                this.itemsFactor2 = this.contribucionItems;
            } else {
                this.itemsFactor2 = this.segundoIdiomaItems;
            }
        },

        onValuate() {
            if (this.valuationType === '1' && this.businessUnitID === 0) {
                this.bInvalidData = true;
                this.errorMessage =
                    'Por favor seleccione una unidad de negocios.';
            } else if (this.puesto === '') {
                this.bInvalidData = true;
                this.errorMessage = 'Por favor escriba el puesto.';
            } else if (this.departmentID === 0) {
                this.bInvalidData = true;
                this.errorMessage = 'Por favor seleccione una dirección.';
            }
            // if (this.usuariosfuncionesid === 0)
            else if (this.valFunctionID === 0) {
                this.bInvalidData = true;
                this.errorMessage =
                    'Por favor seleccione una función o especialidad.';
            } else if (this.usuariosrolesid === 0) {
                this.bInvalidData = true;
                this.errorMessage = 'Por favor seleccione un rol.';
            } else if (this.factor1 === 0) {
                this.bInvalidData = true;
                this.errorMessage =
                    'Por favor seleccione un nivel de ' + this.labelFactor1;
            } else if (this.factor2 === 0) {
                this.bInvalidData = true;
                this.errorMessage =
                    'Por favor seleccione un nivel de ' + this.labelFactor2;
            } else {
                const valuationData = {
                    empresaid: this.company.empresaid,
                    unidadnegocioid: this.businessUnitID,
                    ventas: this.sales,
                    moneda: this.currency,
                    puesto: this.puesto,
                    usuariosdireccionesid: this.departmentID,
                    // usuariosfuncionesid: this.usuariosfuncionesid,
                    empresasfuncionesid: this.valFunctionID,
                    usuariosrolesid: this.usuariosrolesid,
                    numeropuesto1: this.factor1,
                    numeropuesto2: this.factor2
                    //factoresempresaid: this.factoresEmpresaID //CHECAR.
                };
                this.$store.dispatch('valuate', valuationData);
            }
        }
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'company',
            'companySales',
            'companySalesCurrency',
            // 'businessUnits',
            'userBusinessUnits',
            // 'departments',
            'userDepartments',
            'userRoles',
            'userFunctions',
            'companySize',
            // 'factoresEmpresaID',
            'showResultsDlg'
        ]),
        showValFunctionDlg: {
            get() {
                return this.$store.getters.showValFunctionDlg;
            },
            set(showValFunctionDlg) {
                this.$store.dispatch(
                    'updateShowValFunctionDlg',
                    showValFunctionDlg
                );
            }
        },
        valFunctionName: {
            get() {
                return this.$store.getters.valFunctionName;
            },
            set(valFunctionName) {
                this.$store.dispatch('updateValFunctionName', valFunctionName);
            }
        },
        valFunctionID: {
            get() {
                return this.$store.getters.valFunctionID;
            },
            set(valFunctionID) {
                this.$store.dispatch('updateValFunctionID', valFunctionID);
            }
        },
        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
        resultsModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '100%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '60%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background-color: #e0e0e0; /*grey lighten-2 */
}
.exchange_rate {
    background: url('../assets/photo-1499750310107-5fef28a66643.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}
.my-car-table {
    width: 100%;
}
</style>